import axiosClient from "../axiosInstance";
const base = "/rankings";

export const getDistricts = async () => {
  const response = await axiosClient.get(`${base}/districts`);
  return response.data;
};

export const getEvents = async () => {
  const response = await axiosClient.get(`${base}/events`);
  return response.data;
};

export const getPlayerRankingByBsa = async (bsaNumber) => {
  const response = await axiosClient.get(`${base}/bsa/${bsaNumber}`);
  return response.data;
};

export const getRankings = async (params) => {
  const response = await axiosClient.get(`${base}`, { params });
  return response.data;
};

const rankingService = {
  getDistricts,
  getEvents,
  getPlayerRankingByBsa,
  getRankings,
};

export default rankingService;
